export default {
  backPreviousPageTxt: 'Return to previous page'
}


// WEBPACK FOOTER //
// ./src/config/lang/en/system.js